const { hostname } = window.location;

const servers = {
  local: "http://localhost:3017",
  customDev: "https://react.customdev.solutions:3017",
  // live: "https://api.luxuryccs.com",
  live: "https://luxuryccs.com:3017",
};

var URL;
if (hostname.includes("react.customdev.solutions")) URL = servers.customDev;
else if (hostname.includes("luxuryccs.com")) URL = servers.live;
else URL = servers.local;

export const SOCKET_URL = `${URL}`;

export const UPLOADS_URL = URL + "/Uploads/";
export const BASE_URL = URL + "/api";

export const SITE_NAME = "My Website";
export const countries = ["USA", "Canada", "UK"];

export const AUTH = {
  login: "/auth/signin",
};
export const USER_AUTH = {
  login: "/chauffeur/login",
  signup: "/chauffeur/signup",
};
export const CHAUFFEUR = {
  getChauffeur: "/chauffeur/getChauffeur/",
  getDashboardInfo: "/chauffeur/getDashboardInfo",
  toggleActivity: "/chauffeur/toggleActivity",
};
export const COMPANY = {
  getPricing: "/company/getPricing/",
  getProfile: "/company/getProfile/",
};
export const PROFILE = {
  updateProfile: "/chauffeur/updateProfileRequest",
};
export const JOB = {
  getCompanyJobs: "/company/career/getAllJobs/",
  getJob: "/company/career/getJob/",
};
export const JUMP = {
  getMyJumps: "/jump/getMyJumps",
  getJump: "/jump/getJump/",
  getLatestJump: "/jump/getLatestJump/",
};
export const BOOKING = {
  mybookings: "/booking/getMyBookings",
  getbooking: "/booking/getBooking/",
  getMyUpcomingBooking: "/booking/getMyUpcomingBooking",
  getAllBookings: "/booking/getAllBookings",
  getRequestedBookings: "/booking/getRequestedBookings",
  acceptBooking: "/booking/acceptBooking/",
  changeBookingStatus: "/booking/changeBookingStatus/",
  getChauffeurOngoingBooking: "/booking/getChauffeurOngoingBooking",
};
export const EVENT = {
  getupcomingevents: "/company/event/getUpcomingEvents",
  getevent: "/company/event/getEvent/",
};
export const INSTRUCTOR = {
  getAllInstructors: "/company/getAllInstructors/",
  getInstructor: "/company/getInstructor/",
};
export const GIGS = {
  getAllGigs: "/company/getAllGigs",
  getGig: "/company/getGig/",
  getCompanyGigs: "/company/getCompanyGigs/",
};
export const AMENITY = {
  getAmenities: "/amenities/getAmenities",
};
export const SIGNWAIVER = {
  approvePolicy: "/signwaiver/policyApproval",
  getMySignwaivers: "/signwaiver/getMySignwaivers",
};
export const PRODUCT = {
  getVendorProducts: "/product/getAllVendorProducts",
  getProduct: "/product/getProduct/",
  getAdminProducts: "/product/getAllAdminProducts",
};
export const REVIEWS = {
  getGigReviews: "/review/getGigReviews/",
  getProductReviews: "/review/getProductReviews/",
  addReview: "/review/addReview",
  getRoomReviews: "/review/getRoomReviews/",
};
export const RATING = {
  giveRating: "/rating/giveRating",
};
export const RESET = {
  sendCode: "/reset/sendVerificationCode",
  verifyCode: "/reset/verifyRecoverCode",
  resetPassword: "/reset/resetPassword",
  changePassword: "/reset/changePassword",
};
export const COUPON = {
  getCoupons: "/coupon/getCoupons",
  getCoupon: "/coupon/getCoupon/",
};
export const GIFT = {
  addGift: "/gift/addGift",
  utilizeGift: "/gift/utilizeGift",
};
export const ORDER = {
  getMyOrders: "/order/getMyOrders",
  getOrder: "/order/getOrder/",
};
export const STAY = {
  getAllRooms: "/stay/getAllRooms",
  getRoom: "/stay/getRoom/",
};
export const PAYMENT = {
  paymentConfig: "/payment/config",
  paymentIntent: "/payment/create-payment-intent",
  stripeCharge: "/payment/create-stripe-charge",
};
export const FEEDBACK = {
  addFeedback: "/feedback/addFeedback",
};
export const NOTIFICATIONS = {
  getMyNotifications: "/notification/getAllMyNotifications",
  toggleNotification: "/notification/toggleNotification/",
};
export const CAR = {
  getMyCar: "/car/getMyCar",
  updateCarRequest: "/car/updateCarRequest",
  addCar: "/car/addCar",
};
// export const GOOGLE_MAPS = "AIzaSyBXqV9bSEkfm5Wh7OQMj37V-n3F4AiyE40";
export const GOOGLE_MAPS_API = 'AIzaSyBECY2aNK5YkXshm_ZEqtZY0M_hcJT65Iw'

export const USERS = {
  get: "/auth/signin",
};

export const CHAT = {
  createChat: "/chat/createChat",
};
export const MESSAGE = {
  getChatMessages: "/message/getChatMessages/",
  createMessage: "/message/createMessage",
};
export const AVAILABILITY = {
  setHours: "/availabilty/setHours",
  getMyAvailability: "/availabilty/getMyAvailability",
  deleteHours: "/availabilty/deleteHours/",
};

export const ROADS = {
  snapToRoads: "/roads/snapToRoads",
};
export const FARE = {
  getAllLatestFares: "/fare/getAllLatestFares",
};
export const RATES = {
  getAllLatestRates: "/rate/getAllLatestRates",
};
export const TERMS = {
  getTerms: "/terms/getTerms",
};
